var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.preCheckoutData.user_place && !_vm.isEditing
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 p-0" }, [
              _c("div", { staticClass: "card shadow-sm mb-0" }, [
                _c("div", { staticClass: "card-body text-comment" }, [
                  _c("ul", { staticClass: "list-unstyled summary-list" }, [
                    _c("li", [
                      _c("i", { staticClass: "fas fa-user text-secondary" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.preCheckoutData.name) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "pt-2" }, [
                      _c("i", {
                        staticClass: "fas fa-phone-alt text-secondary"
                      }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.preCheckoutData.tel) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "pt-2" }, [
                      _vm.preCheckoutData.user_place
                        ? _c("div", [
                            _c("div", [
                              _c("i", {
                                staticClass: "fas fa-home text-secondary"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.preCheckoutData.user_place.place_name
                                  ) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-2" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.getFullAddress(
                                      _vm.preCheckoutData.user_place
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _c("div", [
                            _c("i", {
                              staticClass: "fas fa-home text-secondary"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.preCheckoutData.address) +
                                "\n              "
                            )
                          ]),
                      _vm._v(" "),
                      _vm.hasUnavailableServiceArea()
                        ? _c("div", { staticClass: "pt-2" }, [
                            _c("div", { staticClass: "text-danger" }, [
                              _c("i", {
                                staticClass: "fas fa-exclamation-circle"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.checkout_step.service_provider_cannot_travel"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-danger pb-3" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.checkout_step.please_contact_admin"
                                    )
                                  ) +
                                  " \n                  "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary-link",
                                  attrs: {
                                    href: "https://line.me/R/ti/p/%40hnk7011n",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Line @BeNeat")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-block btn-outline-info btn-sm",
                                on: {
                                  click: function($event) {
                                    return _vm.openUnavailableServiceAreaModal()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.view_more"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.selectedPetTypes && _vm.selectedPetTypes.length
                      ? _c("li", { staticClass: "pt-2" }, [
                          _c("i", { staticClass: "fas fa-paw text-secondary" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.getPetTypesResult()) +
                              "\n            "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.hasPlaceLocation
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex border border-warning justify-content-start align-items-top -bg-warning-soft rounded-all p-2"
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", { staticClass: "pl-2" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.no_location_warning"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-3 text-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-primary-link",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.isEditing = true
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.booking.checkout_step.edit_data")
                          )
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        : _c(
            "div",
            { staticClass: "form bg-light border border-gray rounded p-3" },
            [
              _c(
                "form",
                {
                  attrs: { action: "", "data-vv-scope": "form-address" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.formSubmit()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "name" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.booking.contact_step.name"))
                      )
                    ]),
                    _vm._v(" "),
                    _vm.preCheckoutData
                      ? _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "name",
                          staticClass: "form-control input-jumbo",
                          class: {
                            "form-alert": _vm.errors.has("form-address.name")
                          },
                          attrs: { type: "text", id: "name", name: "name" },
                          domProps: { value: _vm.preCheckoutData.name },
                          on: {
                            input: function($event) {
                              return _vm.updatePreCheckoutData("name", $event)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.has("form-address.name")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.preBookingData && !_vm.user
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "email" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.booking.booking_step.email"))
                          )
                        ]),
                        _vm._v(" "),
                        _vm.preBookingData
                          ? _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                }
                              ],
                              ref: "email",
                              staticClass: "form-control input-jumbo",
                              class: {
                                "form-alert": _vm.errors.has(
                                  "form-address.email"
                                )
                              },
                              attrs: {
                                type: "email",
                                id: "email",
                                name: "email"
                              },
                              domProps: { value: _vm.preBookingData.email },
                              on: {
                                input: function($event) {
                                  return _vm.updatePreBookingData(
                                    "email",
                                    $event
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("form-address.email")
                          ? _c(
                              "div",
                              { staticClass: "mt-1 text-remark -status-alert" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("message.required_field")) +
                                    "\n        "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "tel" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.booking.contact_step.phone"))
                      )
                    ]),
                    _vm._v(" "),
                    _vm.preCheckoutData
                      ? _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                min: 10,
                                max: 15,
                                regex: /^\+?[0-9-]+$/
                              },
                              expression:
                                "{ required: true, min: 10, max: 15, regex: /^\\+?[0-9-]+$/ }"
                            }
                          ],
                          ref: "tel",
                          staticClass: "form-control input-jumbo",
                          class: {
                            "form-alert": _vm.errors.has("form-address.tel")
                          },
                          attrs: { type: "tel", id: "tel", name: "tel" },
                          domProps: { value: _vm.preCheckoutData.tel },
                          on: {
                            input: function($event) {
                              return _vm.updatePreCheckoutData("tel", $event)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.has("form-address.tel")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm.preCheckoutData.user_place &&
                  _vm.preCheckoutData.user_place.id
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "placeName" } }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("message.my_listings.name")) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.preCheckoutData.user_place.place_name,
                              expression:
                                "preCheckoutData.user_place.place_name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control input-jumbo",
                          class: {
                            "form-alert": _vm.errors.has(
                              "form-address.placeName"
                            )
                          },
                          attrs: {
                            type: "text",
                            id: "placeName",
                            name: "placeName"
                          },
                          domProps: {
                            value: _vm.preCheckoutData.user_place.place_name
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.preCheckoutData.user_place,
                                "place_name",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("form-address.placeName")
                          ? _c(
                              "div",
                              { staticClass: "mt-1 text-remark -status-alert" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("message.required_field")) +
                                    "\n        "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "placeType" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.booking.booking_step.place_size")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-jumbo" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.preCheckoutData.user_place.place_size_id,
                              expression:
                                "preCheckoutData.user_place.place_size_id"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "form-alert": _vm.errors.has(
                              "form-address.addressProvince"
                            )
                          },
                          attrs: { id: "placeType", name: "placeType" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.preCheckoutData.user_place,
                                "place_size_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.booking.booking_step.select_place_size"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.sortedPlaceSizes, function(
                            placeSize,
                            index
                          ) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: _vm.sortedPlaceSizes[index].id
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm._f("multiLangName")(placeSize)) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("form-address.placeType")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "address" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.booking.contact_step.address"))
                      )
                    ]),
                    _vm._v(" "),
                    _vm.preCheckoutData
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "address",
                          staticClass: "form-control",
                          class: {
                            "form-alert": _vm.errors.has("form-address.address")
                          },
                          attrs: { id: "address", name: "address", rows: "2" },
                          domProps: { value: _vm.preCheckoutData.address },
                          on: {
                            input: function($event) {
                              return _vm.updatePreCheckoutData(
                                "address",
                                $event
                              )
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.has("form-address.address")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "addressProvince" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.business.contact_province"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-jumbo" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedAddressProvinceId,
                              expression: "selectedAddressProvinceId"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "form-alert": _vm.errors.has(
                              "form-address.addressProvince"
                            )
                          },
                          attrs: {
                            id: "addressProvince",
                            name: "addressProvince"
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedAddressProvinceId = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.booking.contact_step.set_province"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.sortedProvinces, function(
                            addressProvince,
                            index
                          ) {
                            return _c(
                              "option",
                              { domProps: { value: addressProvince.id } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("multiLangName")(addressProvince)
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("form-address.addressProvince")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 pr-2 pl-0" }, [
                      _c("label", { attrs: { for: "district" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.booking.contact_step.district")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "select-jumbo" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedDistrictId,
                                expression: "selectedDistrictId"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              "form-alert": _vm.errors.has(
                                "form-address.district"
                              )
                            },
                            attrs: { id: "district", name: "district" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedDistrictId = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.set_district"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sortedDistricts, function(
                              district,
                              index
                            ) {
                              return _c(
                                "option",
                                { domProps: { value: district.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("multiLangName")(district)
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.errors.has("form-address.district")
                        ? _c(
                            "div",
                            { staticClass: "mt-1 text-remark -status-alert" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("message.required_field")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 pl-2 pr-0" }, [
                      _c("label", { attrs: { for: "sub-district" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.booking.contact_step.sub_district")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "select-jumbo" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedSubDistrictId,
                                expression: "selectedSubDistrictId"
                              }
                            ],
                            attrs: { id: "sub-district" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedSubDistrictId = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.set_sub_district"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sortedSubDistricts, function(
                              subDistrcict,
                              index
                            ) {
                              return _c(
                                "option",
                                { domProps: { value: subDistrcict.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("multiLangName")(subDistrcict)
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "remark" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.booking.contact_step.remark"))
                      )
                    ]),
                    _vm._v(" "),
                    _vm.preCheckoutData
                      ? _c("textarea", {
                          ref: "remark",
                          staticClass: "form-control textarea-jumbo",
                          attrs: {
                            id: "remark",
                            rows: "3",
                            placeholder: _vm.$t(
                              "message.booking.contact_step.remark_placeholder"
                            )
                          },
                          domProps: { value: _vm.preCheckoutData.remark },
                          on: {
                            input: function($event) {
                              return _vm.updatePreCheckoutData("remark", $event)
                            }
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("pet-selection-label"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center pt-2"
                        },
                        [
                          _c("div", { staticClass: "flex-fill" }, [
                            _c("label", [
                              _c("i", { staticClass: "fas fa-paw" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.contact_step.pet_remark"
                                    )
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("toggle-button", {
                                attrs: { sync: true, color: "#8BC34A" },
                                on: { change: _vm.onChangeHasPet },
                                model: {
                                  value: _vm.switchHasPet,
                                  callback: function($$v) {
                                    _vm.switchHasPet = $$v
                                  },
                                  expression: "switchHasPet"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isClearing
                        ? _c(
                            "div",
                            { staticClass: "py-2" },
                            [_c("loader-small")],
                            1
                          )
                        : _c("div", [
                            _vm.selectedPetTypes
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-start align-items-center flex-wrap"
                                  },
                                  _vm._l(_vm.selectedPetTypes, function(
                                    petType
                                  ) {
                                    return _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-start align-items-center bg-white border border-chip-gray rounded-pill px-2 py-1 mr-2 mb-2"
                                        },
                                        [
                                          petType.image_url
                                            ? _c(
                                                "div",
                                                { staticClass: "pr-2" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: petType.image_url,
                                                      width: "24"
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("multiLangName")(petType)
                                              ) + " "
                                            ),
                                            petType.remark
                                              ? _c("span", [
                                                  _vm._v(
                                                    ":" + _vm._s(petType.remark)
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    ])
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pt-3" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("message.booking.contact_step.location"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card my-0 border-divider",
                        class: {
                          "border-danger": _vm.errors.has(
                            "form-address.location"
                          )
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: !_vm.hasPlaceLocation },
                                expression: "{ required: !hasPlaceLocation }"
                              }
                            ],
                            staticClass: "card-body p-2"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-start align-items-center"
                              },
                              [
                                _c("div", { staticClass: "flex-fill" }, [
                                  _vm.hasPlaceLocation
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "fal fa-check-circle text-success fa-lg"
                                        }),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.contact_step.pinned_location"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "fal fa-exclamation-circle text-danger fa-lg"
                                        }),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.contact_step.unpinned_location"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-info",
                                      on: {
                                        click: function($event) {
                                          return _vm.openPinlocationModal()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.hasPlaceLocation
                                              ? _vm.$t("message.button.edit")
                                              : _vm.$t("message.button.add")
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errors.has("form-address.location")
                      ? _c(
                          "div",
                          { staticClass: "text-remark -status-alert mt-1" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.preCheckoutData.user_place.id && _vm.isEditing
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-block -pink mt-3",
                            attrs: { disabled: _vm.isSavingUserPlace },
                            on: { click: _vm.saveMyPlace }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.isSavingUserPlace
                                    ? _vm.$t("message.button.loading")
                                    : _vm.$t(
                                        "message.booking.contact_step.save_my_place"
                                      )
                                ) +
                                "\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-primary pt-3 text-center" },
                          [
                            _c("i", {
                              staticClass: "fal fa-lightbulb-exclamation fa-lg"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.alert_saving_data"
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row no-gutters" }, [
                    _vm.user && !_vm.state.isAddedUserPlace
                      ? _c("div", { staticClass: "col-12 text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-block -pink mt-3",
                              on: { click: _vm.openSavePlaceModal }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.save_my_place"
                                  )
                                ) + "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-3" }, [
                            _vm._m(3),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.save_my_place_tips"
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("save-place-modal", {
                ref: "savePlaceModal",
                attrs: { selectedPetTypes: _vm.selectedPetTypes }
              }),
              _vm._v(" "),
              _c("pet-type-modal", {
                ref: "petTypeModal",
                on: { onUpdateResult: _vm.updateUserPlacePetTypes }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c("unavailable-service-area-modal", {
        ref: "unavailableServiceAreaModal"
      }),
      _vm._v(" "),
      _c("pin-location-modal", {
        ref: "pinLocationModal",
        attrs: { settings: _vm.settings },
        on: { savedLocation: _vm.clearLocationError }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-exclamation-circle text-danger fa-lg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-4" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-4" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-primary text-remark" }, [
      _c("i", { staticClass: "far fa-lightbulb" }),
      _vm._v(" Tips!")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ba2fb71", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba2fb71","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/ContactForm.vue
// module id = 1846
// module chunks = 0